"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CombinedSessionItem = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
var _tokens = require("../tokens");
var _SessionStorage = require("./SessionStorage");
class CombinedSessionItem {
  constructor() {
    (0, _defineProperty2.default)(this, "storage", new _SessionStorage.SessionStorage());
  }
  remove() {
    this.storage.removeItem(_constants.USER_TOKEN_STORAGE_KEY);
    this.storage.removeItem(_constants.ANONYMOUS_TOKEN_STORAGE_KEY);
    return this;
  }
  get() {
    const userToken = this.storage.getItem(_constants.USER_TOKEN_STORAGE_KEY);
    const anonymousToken = this.storage.getItem(_constants.ANONYMOUS_TOKEN_STORAGE_KEY);

    // If user token is present then user was probably logged in already
    if (userToken) {
      return userToken;
    }
    if (anonymousToken) {
      return anonymousToken;
    }
    return null;
  }
  set(value) {
    this.remove();
    const parsedToken = new _tokens.OidcToken(value.Token);
    const customerId = parsedToken.getClaim('customer_id');
    const isUserSignedIn = typeof customerId === 'number' && customerId > 0;
    const key = isUserSignedIn ? _constants.USER_TOKEN_STORAGE_KEY : _constants.ANONYMOUS_TOKEN_STORAGE_KEY;
    this.storage.setItem(key, value);
    return this;
  }
}
exports.CombinedSessionItem = CombinedSessionItem;
//# sourceMappingURL=CombinedSessionItem.js.map